<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth" :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="productKitId" :primary-key="form.productKitId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.productKitId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <b-col cols="9">
                <t-input-product :status="status" :add-error="error.relationProductId" ref="firstInput" @focusout="focusByRef('input_quantity')" :command="command" v-model="form.relationProductId" required />
              </b-col>

              <t-input cols="3" v-model="form.quantity" submitted number :decimals="4"  ref="input_quantity" label="Quantidade" required />


            </b-row>

<!--            <t-input cols="3" v-model="form.note" label="Observação"/>-->

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" tabindex="3" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>


      </b-col>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import ui from "@/assets/scripts/ui";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProductKit',
  data() {
    return {
      path: "product/item-kit", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "productId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "productKitId", keyDelete: "productKitId"},
        {key: "relationProductCodeLabel", label: "Produto", cols: "3"},
        {key: "relationProductNameAutomatically", label: "Descrição", cols: "5"},
        {key: "quantity", label: "Quantidade", cols: "2", formatter:"number"},
      ],
      form: {
        productId: this.foreignKey,
        productKitId: 0,
        relationProductId:0,
        quantity: 0,
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        relationProductId:"",
        codeGeneratorPrefix: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------

      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.focusByRef('firstInput')

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      if(this.form.productId === this.form.relationProductId){
        ui.msgError(this,"Não é permitido incluir o próprio produto na relação de itens do kit")
      }else{
        await this.setSendingFormListDefault(this.form.productKitId)
      }



    },

    mountedList() {

      this.focusByRef('firstInput')

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
